import { TextField } from "@mui/material";
import { formatISO } from "date-fns";
import { Field } from "react-final-form";

export default function DataFilterDatePicker({
    name,
    label,
    defaultValue,
    required = false,
    databaseFilter = false,
    doFilter,
    sx,
}) {
    return (
        <Field name={name} defaultValue={formatISO(defaultValue, { representation: "date" })}>
            {(props) => (
                <TextField
                    type="date"
                    label={label}
                    variant="standard"
                    InputLabelProps={{ shrink: true }}
                    error={props.meta.error && props.meta.touched}
                    helperText={props.meta.touched ? props.meta.error : ""}
                    sx={{ mt: 1, mr: 1, ...sx }}

                    {...props.input}
                />
            )}
        </Field>
    );
}
